import { NUU_COOKIE_NOTIFICATIONS } from '~coreModules/core/js/cookie-constants';

import {
    NOTIFICATIONS_GLOBAL_DISALLOWED_ROUTES,
} from '~coreModules/notifications/js/notifications-constants';

// eslint-disable-next-line import/prefer-default-export
export function isNotificationPageBlocked(routePath, notification) {
    const { allowedPages, blockedPages = [] } = notification;

    let isBlockedPage = false;

    // First check if the page is in the list of allowed pages
    if (allowedPages) {
        isBlockedPage = !allowedPages.find(allowedPage => routePath.includes(allowedPage));
    }

    if (!isBlockedPage) {
        // Then check if the page is in the list of blocked pages
        // This should override any allowedPages
        const allBlockedPages = blockedPages.concat(NOTIFICATIONS_GLOBAL_DISALLOWED_ROUTES);
        isBlockedPage = !!allBlockedPages.find(blockedPage => routePath.includes(blockedPage));
    }

    return isBlockedPage;
}

/*
    Filters notifications based on allowed notifications and cookies
    @param {Array} notifications - Array of notifications
    @param {Array} allowedNotifications - Array of allowed notification IDs
    @param {Object} cookies - Cookies object
    @returns {Array} - Filtered array of notifications
*/
export function filterNotifications(notifications, allowedNotifications, cookies) {
    return notifications.filter(({ notificationId }) => {
        const hasSeen = cookies.get(`${NUU_COOKIE_NOTIFICATIONS}_${notificationId}`);
        return !hasSeen && allowedNotifications.includes(notificationId);
    });
}
